import "./TransportSimulation.css"
import { useState } from "react";
import MultiSelector from "../components/MultiSelector";
import StartSelector from "../components/StartSelector";
import DestinationSelector from "../components/DestinationSelector";
import MidPage from "../components/MidPageMaps";



export default function TransportSimulation(){

    const [TransportMeansValue, setTransportMeansValue] = useState([])
    const [ThemeSelectorValue, setThemeSelectorValue] = useState([])
    const [StartSelectorValue, setStartSelectorValue] = useState([])
    const [DestinationSelectorValue, setDestinationSelectorValue] = useState([])
    const [RoadTransportThemeSelectorValue, setRoadTransportThemeSelectorValue] = useState([])
    


    let TrasportMeansSelector = {
        title: "0.1 Επιλέξτε Υποσύστημα Μεταφορών",
        options: [{key: 'Οδικές'},{key: 'Σιδηροδρομικές'}, {key: 'Θαλάσσιες'}, {key: 'Αεροπορικές'}]
    }

    let ThemeSelector = {
        title: "0.2 Επιλέξτε Θεματικά Επίπεδα",
        options: [{key: 'Θέση'},{key: 'Κίνηση επιβατών'}]
    }

    let RoadTransportThemeSelector = {
        title: "0.2 Επιλέξτε Θεματικά Επίπεδα",
        options: [{key: 'Θέση'},{key: 'Κυκλοφοριακές ζώνες'}, {key: 'Μετακινήσεις (ΕΜΗΚ) μεταξυ κυκλοφοριακών ζωνών'}, {key: "Οδικά Τμήματα: Ιεράρχηση"},
        {key: "Οδικά Τμήματα: Αριθμός λωρίδων"}, {key: "Οδικά Τμήματα: Ταχύτητα ελεύθερης ροής"},{key: "Οδικά Τμήματα: Λόγος v/c"},{key: "Οδικά Τμήματα: Κυκλοφοριακός φόρτος (ΕΜΗΚ)"}, {key: "Οδικά Τμήματα: Διανυθέντα οχηματοχιλιόμετρα"}, {key: "Οδικά Τμήματα: Διανυθέντες οχηματοώρες"}]
    }


 

        
    //function for downloading the shapefiles
    function downloadZip(param){
        // var param = 'airtransport-links'
        fetch("api/download/"+param)
        .then(res => res.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = "download.zip";
            document.body.appendChild(link);
            // Trigger the download
            link.click();
            // Clean up the URL and link
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        })
        .catch((error) => {
        console.log("Error sending zip")
        });
    };


    let component;
    // && (ThemeSelectorValue.length !== 0 || RoadTransportThemeSelectorValue.length !==0)
    if(TransportMeansValue.length!== 0 && (ThemeSelectorValue.length !== 0 || RoadTransportThemeSelectorValue.length !==0)){
        console.log("hey", TransportMeansValue)
        switch(TransportMeansValue[0]){
            case 'Οδικές':
                if(RoadTransportThemeSelectorValue.includes("Θέση")){
                    component =  <div className="container">                      
                                    <button onClick={() => downloadZip("roadtransport-position")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }else if(RoadTransportThemeSelectorValue.includes('Μετακινήσεις (ΕΜΗΚ) μεταξυ κυκλοφοριακών ζωνών')){
                    component = <div className="container">                      
                                    <button onClick={() => downloadZip("roadtransport-zones-links")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }else if(RoadTransportThemeSelectorValue.includes("Κυκλοφοριακές ζώνες")){
                    component = <div className="container">                      
                                    <button onClick={() => downloadZip("roadtransport-zones")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>

                }else{
                    component = <div className="container">                      
                                    <button onClick={() => downloadZip("roadtransport-links")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }
                break;
            case 'Σιδηροδρομικές':
                if(ThemeSelectorValue[0] === "Θέση"){
                    component =  <div className="container">
                                    
                                    <button onClick={() => downloadZip("railtransport-position")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }else{
                    component =  <div className="container">
                                    
                                    <button onClick={() =>downloadZip("railtransport-links")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }

                break;
            case 'Θαλάσσιες':
                if(ThemeSelectorValue[0] === "Θέση"){
                    component = <div className="container">
                                    
                                    <button onClick={() =>downloadZip("marinetransport-position")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }else{
                    component = <div className="container">
                                    
                                    <button onClick={() =>downloadZip("marinetransport-links")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }
                break;
            case 'Αεροπορικές':
                if(ThemeSelectorValue[0] === "Θέση"){
                    component =   <div className="container">
                                    
                                    <button onClick={() =>downloadZip("airtransport-position")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }else{
                    component =   <div className="container">
                                    
                                    <button onClick={() =>downloadZip("airtransport-links")} style = {{ width: "70%", backgroundColor: "rgb(0, 98, 255)", color: "white", marginBottom: "5%", border: "none"}}>Κατέβασε shape files</button>
                                </div>
                }
            break;
            default:
            }
    }

    return(
        <div>
            <div className="container SelectorsContainer">
    
                <MultiSelector passData = {setTransportMeansValue} props = {TrasportMeansSelector} selectionsLimit = {1} ResetFlag = {setRoadTransportThemeSelectorValue} ResetThemeSelectorFlag = {setThemeSelectorValue} ResetOrigin = {setStartSelectorValue} ResetDestination = {setDestinationSelectorValue}/>
                {TransportMeansValue[0] === "Οδικές"? <MultiSelector passData = {setRoadTransportThemeSelectorValue} props = {RoadTransportThemeSelector} selectionsLimit = {1}/> : <></>}
                {/* TODO FIX IT AGAIN TO selectionsLimit = -1 */}
                {TransportMeansValue.length!== 0 && TransportMeansValue[0] !== "Οδικές"? <MultiSelector passData = {setThemeSelectorValue} props = {ThemeSelector} selectionsLimit = {1}></MultiSelector> : <></>}
                
                {   ThemeSelectorValue.length !== 0 || RoadTransportThemeSelectorValue.length !== 0 ?
                        ThemeSelectorValue.includes("Κίνηση επιβατών") || RoadTransportThemeSelectorValue.includes('Μετακινήσεις (ΕΜΗΚ) μεταξυ κυκλοφοριακών ζωνών')?
                        <div id = "StartDestSelectorsDiv">
                            <StartSelector passData = {setStartSelectorValue} TransportMeansSelection = {TransportMeansValue}></StartSelector>
                            {StartSelectorValue.length !== 0 ?
                                <DestinationSelector passData = {setDestinationSelectorValue} origin = {StartSelectorValue} TransportMeansSelection = {TransportMeansValue} > </DestinationSelector>: <></>
                            }
                        </div>
                        : <></>
                    :<></>
                }
            </div>
            
            
           
          
            {TransportMeansValue.length!== 0 && (ThemeSelectorValue.length !== 0 || RoadTransportThemeSelectorValue.length !==0)?
                <div>
                    {/* Component is Download shapefiles button */}
                    {component}
                <MidPage ThemeSelection = {ThemeSelectorValue} RoadTransportThemeSelection = {RoadTransportThemeSelectorValue} TransportMeansSelection = {TransportMeansValue} OriginSelectorValue = {StartSelectorValue} destinations = {DestinationSelectorValue}></MidPage>
                </div>:<></>}
            


           
        </div>
    )
}